export const LOCAL_URL = 'http://localhost:3003'
export const DEV_URL = 'http://www.digitalsignature-dev.middlewarecrunch.com:3002';
export const PROD_URL = 'https://crunchauth.com:9002';


export const EXPIRATION_DAYS = 30;